import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { IRootState } from './types';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';
import { reducers } from './reducers';

const initialState: IRootState = {
  managerPermissions: {} as IRootState['managerPermissions'],
  employeePermissions: {} as IRootState['employeePermissions'],
  isOpenIntegrationNav: false,
  dorIntegration: {} as IRootState['dorIntegration'],
  dorLocations: [],
  isOpenDorDialog: false,
  integrations: {} as IRootState['integrations'],
};

export const slice = createSlice({
  name: STORE_SLICES.SETTINGS,
  initialState,
  reducers,
});

const settingsActions = slice.actions;

const settingsPersistConfig = {
  key: PERSIST_KEYS.SETTINGS,
  storage,
};

export {
  settingsActions,
};

export default persistReducer(settingsPersistConfig, slice.reducer);
